var map = {
	"./star.png": 110,
	"./star@2x.png": 111,
	"./star@3x.png": 112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/star.*\.png$
// module id = 199
// module chunks = 3